import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import ArmonizacionContable from "./components/ArmonizacionContable/ArmonizacionContable";
import Licitaciones from "./components/Licitaciones/Licitaciones";
import CPublica from "./components/cpublica/cpublica";
import LigasInteres from "./components/ligasInteres/ligasInteres";
import UEEPCI from "./components/UEEPCI/UEEPCI";
import Error404 from "./components/Error404/Error404";

function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Transparencia/Agenda" element={ <Agenda/> } />
          <Route exact path="/Transparencia/Armonizacion" element={ <ArmonizacionContable /> } />
          <Route exact path="/Transparencia/Licitaciones" element={<Licitaciones/>} />
          <Route exact path="/Transparencia/AContable/cpublica" element={<CPublica/>} />
          <Route exact path="/Transparencia/Normatividad/ligasInteres" element={<LigasInteres/>} />
          <Route exact path="/Transparencia/Normatividad/UEEPCI" element={<UEEPCI/>} />
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
